import { createSelector } from 'reselect';

import { IIntState } from '../../../../modules/internationalization/intReducer';
import { selectInt } from '../../../../modules/internationalization/intSelectors';
import { infoApi } from './store';

/*
* -------------------------------------------
*               Translation
* -------------------------------------------
*/

export const infoTranslationSelector = () =>
    createSelector(
        selectInt,
        (state: IIntState) => state.translation.pageSubscriberId.tabs.info,
    );

/*
* -------------------------------------------
*               Api
* -------------------------------------------
*/

const infoTariffApiSelector = (subscriberId: string, regionId?: number) =>
    infoApi.endpoints.getTariff.select({ subscriberId, regionId });

export const infoTariffDiscountsSelector = (subscriberId: string, regionId?: number) => createSelector(
    infoTariffApiSelector(subscriberId, regionId),
    tariff => tariff?.data?.discounts ?? [],
)
